import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logout, authorizeToken } from "../../../actions/auth";
import GreenLogo from "./GreenLogo";

const TwoFARequest = ({
  authorizeToken,
  logout,
  setShowAuthentication,
  channelid,
  firstname,
  lastname,
  jobtitle,
  location,
}) => {
  const [formData, setFormData] = useState({
    token: "",
  });

  const { token } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (token !== "") {
      authorizeToken(token, channelid);
    }
  };

  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() => {
              logout();
              setShowAuthentication(false);
            }}
          ></i>
          <div className="flex-center">
            <div className="index-logo-alt">
              <GreenLogo />
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">{channelid}</span>
                </li>
                <li className="user-online-item">
                  {firstname} {lastname}
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text white">
            Enter the code emailed to the email address for your account to
            complete the selected required two-factor authentication. This token
            will expire in approximately five minutes.
          </div>
          <form
            className="form-control"
            method="POST"
            onSubmit={(e) => onSubmit(e)}
          >
            <label htmlFor="email" className="token-labels-input green">
              *Token:
            </label>
            <input
              className="forgot-password-input"
              type="text"
              name="token"
              placeholder="Enter Token"
              onChange={(e) => onChange(e)}
            />
            <div className="flex-center">
              <button className="user-request-button background-green">
                <i className="far fa-check-circle fa-sm mr-5"></i>
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

TwoFARequest.propTypes = {
  auth: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { authorizeToken, logout })(
  TwoFARequest
);
